import AddNoteRequest from './add-note-request.vue';
import BankruptcyAddRepresentative from './bankruptcy/add-representative.vue';
import BankruptcyObjectionRequest from './bankruptcy/objection-request.vue';
import BankruptcyGeneralRequest from './bankruptcy/general-request.vue';
import BankruptcyObjectionToProcedureOrDecisionRequest from './bankruptcy/general-requests/objection-to-procedure-or-decision-request.vue';
import BuildingInfo from './building-info';
import CaseJudgementDocument from './case-judgement-document';
import JudgementDocument from './case-judgement-document/judgement-document-by-code.vue';
import CasePartyRepresentative from './case-party-representative.vue';
import CassationRequest from './cassation-request.vue';
import CheckMarriageDeed from './check-deeds/marriage.vue';
import CheckHeirsData from './check-heirs-data';
import CheckMoiPersonalInfo from './check-moi-personal-info';
import ContractDetails from './contract-details';
import CorrectionOrInterpretationOfJudgmentRequest from './correction-or-interpretation-of-judgment-request.vue';
import DismissedCaseRequest from './dismissed-case-request.vue';
import EvacuationContractDetails from './evacuation-contract-details/index.vue';
import ExecutionRequestDetails from './execution-request-details';
import FundsHoldRequest from './funds-hold-request';
import IncidentalRequest from './incidental-request.vue';
import IntervenorRequest from './intervenor-request.vue';
import JoinderRequest from './joinder-request.vue';
import JointRealEstateDivisionDeedInfo from './joint-real-estate-division-deed-info';
import JudgeRejectionRequest from './judge-rejection-request.vue';
import JudicialInforming from './judicial-informing';
import LiftReferRequest from './lift-refer-request';
import LiftTravelPreventionRequest from './lift-travel-prevention-request.vue';
import LitigationAbandonmentsRequest from './litigation-abandonments-request';
import OverlappingRealEstateDeedInfo from './overlapping-real-estate-deed-info';
import OwnershipDeedInfo from './ownership-deed-info';
import PreviousArbitrationInsertion from './previous-arbitration-insertion';
import RealEstateContractDetails from './real-estate-contract-details';
import RealEstateEvacuationDeedInfo from './real-estate-evacuation-deed-info';
import ReconsiderationRequest from './reconsideration-request.vue';
import RemoveAgentFromCaseRequest from './remove-agent-from-case-request.vue';
import RightOfFirstPreemptionDeedInfo from './right-of-first-preemption-deed-info';
import StopFundsHoldRequest from './stop-funds-hold-request';
import StopResumeLawsuitRequest from './stop-resume-lawsuit-request.vue';
import TravelPreventionRequest from './travel-prevention-request.vue';
import VerdictObjectionRequest from './verdict-objection-request.vue';
import WaiverOfAppealRequest from './waiver-of-appeal-request.vue';
import ProceedAbandonedCase from './proceed-abandoned-case';
import ViewCaseRecord from './view-case-record-request';
import CorrectionJudgementRequest from './correction-judgement-request';
import InterpretationJudgementRequest from './interpretation-judgement-request';
import ReplyMemoForm from './bankruptcy/reply-memo.vue';
import reconsiderationFromNonCaseParty from './reconsideration-from-non-case-party';
import WaiverRequest from './waiver-request.vue';

import { local } from '@/local';

export default [
  {
    name: 'التحقق من بيانات صك حصر الورثه - CheckHeirsData',
    value: 'CheckHeirsData',
    component: CheckHeirsData,
    fieldsTechnicalNames: [
      {
        label: 'اسم المورث',
        name: 'deceasedFullName',
      },
      {
        label: 'تاريخ الوفاة',
        name: 'deceasedDeathDate',
      },
      {
        label: 'النوع',
        name: 'deceasedGender',
      },
    ],
  },
  {
    name: 'CasePartyRepresentative',
    value: 'CasePartyRepresentative',
    component: CasePartyRepresentative,
    fieldsTechnicalNames: [],
  },
  {
    name: 'IntervenorRequest',
    value: 'IntervenorRequest',
    component: IntervenorRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'VerdictObjectionRequest',
    value: 'VerdictObjectionRequest',
    component: VerdictObjectionRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'ReconsiderationRequest',
    value: 'ReconsiderationRequest',
    component: ReconsiderationRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'JoinderRequest',
    value: 'JoinderRequest',
    component: JoinderRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'DismissedCaseRequest',
    value: 'DismissedCaseRequest',
    component: DismissedCaseRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'StopResumeLawsuitRequest',
    value: 'StopResumeLawsuitRequest',
    component: StopResumeLawsuitRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'WaiverRequest',
    value: 'WaiverRequest',
    component: WaiverRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'TravelPreventionRequest',
    value: 'TravelPreventionRequest',
    component: TravelPreventionRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'LiftTravelPreventionRequest',
    value: 'LiftTravelPreventionRequest',
    component: LiftTravelPreventionRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'CorrectionOrInterpretationOfJudgmentRequest',
    value: 'CorrectionOrInterpretationOfJudgmentRequest',
    component: CorrectionOrInterpretationOfJudgmentRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'RemoveAgentFromCaseRequest',
    value: 'RemoveAgentFromCaseRequest',
    component: RemoveAgentFromCaseRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'FundsHoldRequest',
    value: 'FundsHoldRequest',
    component: FundsHoldRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'StopFundsHoldRequest',
    value: 'StopFundsHoldRequest',
    component: StopFundsHoldRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'CassationRequest',
    value: 'CassationRequest',
    component: CassationRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'AddNoteRequest',
    value: 'AddNoteRequest',
    component: AddNoteRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'JudgeRejectionRequest',
    value: 'JudgeRejectionRequest',
    component: JudgeRejectionRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'LitigationAbandonmentsRequest',
    value: 'LitigationAbandonmentsRequest',
    component: LitigationAbandonmentsRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'IncidentalRequest',
    value: 'IncidentalRequest',
    component: IncidentalRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'WaiverOfAppealRequest',
    value: 'WaiverOfAppealRequest',
    component: WaiverOfAppealRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'LiftReferRequest',
    value: 'LiftReferRequest',
    component: LiftReferRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'ProceedAbandonedCase',
    value: 'ProceedAbandonedCase',
    component: ProceedAbandonedCase,
    fieldsTechnicalNames: [],
  },
  {
    name: 'ViewCaseRecord',
    value: 'ViewCaseRecord',
    component: ViewCaseRecord,
    fieldsTechnicalNames: [],
  },
  {
    name: 'CorrectionJudgementRequest',
    value: 'CorrectionJudgementRequest',
    component: CorrectionJudgementRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'InterpretationJudgementRequest',
    value: 'InterpretationJudgementRequest',
    component: InterpretationJudgementRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'reconsiderationFromNonCaseParty',
    value: 'reconsiderationFromNonCaseParty',
    component: reconsiderationFromNonCaseParty,
    fieldsTechnicalNames: [],
  },
  {
    name: 'بيانات العقار - BuildingInfo',
    value: 'BuildingInfo',
    component: BuildingInfo,
    fieldsTechnicalNames: [
      {
        label: 'وصف العقار',
        name: 'buildingType',
      },
      {
        label: 'المدينة',
        name: 'city',
      },
      {
        label: 'الحي',
        name: 'district',
      },
      {
        label: 'مصدر الصـك',
        name: 'buildingOwnershipDeedSource',
      },
      {
        label: 'الرقم',
        name: 'buildingOwnershipDeedNumber',
      },
      {
        label: 'تاريخ',
        name: 'buildingOwnershipDeedDate',
      },
      {
        label: 'مساحه',
        name: 'buildingOwnershipDeedArea',
      },
    ],
  },
  {
    name: 'الاستعلام عن الصكوك برقم الصك و تاريخ الصك- OwnershipDeedInfo',
    value: 'OwnershipDeedInfo',
    component: OwnershipDeedInfo,
    fieldsTechnicalNames: [],
    showValidationList: true,
  },
  {
    name: 'معلومات صك الملكية - نموذج إخلاء عقار - RealEstateEvacuationDeedInfo',
    value: 'RealEstateEvacuationDeedInfo',
    component: RealEstateEvacuationDeedInfo,
    fieldsTechnicalNames: [],
  },
  {
    name: 'معلومات صك الملكية - نموذج تداخل عقارات - OverlappingRealEstateDeedInfo',
    value: 'OverlappingRealEstateDeedInfo',
    component: OverlappingRealEstateDeedInfo,
    fieldsTechnicalNames: [],
  },
  {
    name: 'معلومات صك الملكية - نموذج حق الشفعة - RightOfFirstPreemptionDeedInfo',
    value: 'RightOfFirstPreemptionDeedInfo',
    component: RightOfFirstPreemptionDeedInfo,
    fieldsTechnicalNames: [],
  },
  {
    name: 'معلومات صك الملكية - بيانات العقار (قسمة عقارات مشتركة) - JointRealEstateDivisionDeedInfo',
    value: 'JointRealEstateDivisionDeedInfo',
    component: JointRealEstateDivisionDeedInfo,
    fieldsTechnicalNames: [],
  },
  {
    name: 'بيانات العقد المبرم بين الطرفين - RealEstateContractDetails',
    value: 'RealEstateContractDetails',
    component: RealEstateContractDetails,
    fieldsTechnicalNames: [],
  },
  {
    name: 'ContractDetails-تفاصيل العقد(أجرة عقار)',
    value: 'ContractDetails',
    component: ContractDetails,
    fieldsTechnicalNames: [],
  },
  {
    name: 'EvacuationContractDetails-تفاصيل العقد(إخلاء عقار)',
    value: 'EvacuationContractDetails',
    component: EvacuationContractDetails,
    fieldsTechnicalNames: [],
  },
  {
    name: 'CaseJudgementDocument-صك الحكم',
    value: 'CaseJudgementDocument',
    component: CaseJudgementDocument,
    fieldsTechnicalNames: [{
      label: 'رقم القضية',
      name: 'caseCode',
    },
    {
      label: 'رقم الهوية',
      name: 'identityNumber',
    }],
  },
  {
    name: 'JudgementDocument-(رقم صك الحكم)',
    value: 'JudgementDocument',
    component: JudgementDocument,
    fieldsTechnicalNames: [{
      label: 'رقم صك الحكم',
      name: 'judgementCode',
    }],
    showValidationList: true,
  },
  {
    name: 'JudicialInforming-(ربط برقم إخطار أداء الحق في منصة التبليغ العدلي مع صحائف الدعوى)',
    value: 'JudicialInforming',
    component: JudicialInforming,
    fieldsTechnicalNames: [{
      label: 'ربط برقم إخطار أداء الحق في منصة التبليغ العدلي مع صحائف الدعوى',
      name: 'JudicialInforming',
    }],
    showValidationList: true,
  },
  {
    name: 'بيانات طلبات التنفيذ',
    value: 'ExecutionRequestDetails',
    component: ExecutionRequestDetails,
    fieldsTechnicalNames: [
      {
        label: 'نوع الهوية',
        name: 'identityTypeId',
      },
      {
        label: 'رقم الهوية',
        name: 'identityId',
      },
    ],
  },
  {
    name: local.personInformation.checkMoiPersonalInfoService,
    value: 'CheckMoiPersonalInfo',
    component: CheckMoiPersonalInfo,
    fieldsTechnicalNames: [
      {
        label: local.personInformation.socialType,
        name: 'socialTypeText',
      },
      {
        label: local.personInformation.social,
        name: 'socialId',
      },
      {
        label: local.personInformation.dateOfBirth,
        name: 'dateOfBirth',
      },
      {
        label: local.personInformation.age,
        name: 'age',
      },
      {
        label: local.personInformation.firstName,
        name: 'firstName',
      },
      {
        label: local.personInformation.fatherName,
        name: 'fatherName',
      },
      {
        label: local.personInformation.grandFatherName,
        name: 'grandFatherName',
      },
      {
        label: local.personInformation.familyName,
        name: 'familyName',
      },
      {
        label: local.personInformation.nationality,
        name: 'nationalityText',
      },
      {
        label: local.personInformation.sex,
        name: 'sexText',
      },
    ],
  },
  {
    name: 'CheckMarriageDeed-(التحقق من حالة الزواج)',
    value: 'CheckMarriageDeed',
    component: CheckMarriageDeed,
    fieldsTechnicalNames: [
      {
        label: 'رقم هوية الزوج',
        name: 'HusbandNationalId',
      },
      {
        label: 'تاريخ ميلاد الزوج',
        name: 'HusbandBirthDate',
      },
      {
        label: 'رقم هوية الزوجة',
        name: 'WifeNationalId',
      },
      {
        label: 'تاريخ ميلاد الزوجة',
        name: 'WifeBirthDate',
      }],
    showValidationList: true,
  },
  {
    name: 'BankruptcyObjectionRequest',
    value: 'BankruptcyObjectionRequest',
    component: BankruptcyObjectionRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'إيداع حكم تحكيم سابق',
    value: 'PreviousArbitrationInsertion',
    component: PreviousArbitrationInsertion,
    fieldsTechnicalNames: [{
      label: 'رقم طلب صحيفة الدعوى',
      name: 'arbitrationRequestCode',
    }],
  },
  {
    name: 'BankruptcyAddRepresentative',
    value: 'BankruptcyAddRepresentative',
    component: BankruptcyAddRepresentative,
    fieldsTechnicalNames: [],
  },
  {
    name: 'BankruptcyGeneralRequest',
    value: 'BankruptcyGeneralRequest',
    component: BankruptcyGeneralRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'BankruptcyObjectionToProcedureOrDecisionRequest',
    value: 'BankruptcyObjectionToProcedureOrDecisionRequest',
    component: BankruptcyObjectionToProcedureOrDecisionRequest,
    fieldsTechnicalNames: [],
  },
  {
    name: 'ReplyMemoForm',
    value: 'ReplyMemoForm',
    component: ReplyMemoForm,
    fieldsTechnicalNames: [],
  },
];
